/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { PATH } from '#const/path';
import { useScheduleCoachListQuery } from '#hooks/queries/schedules/useScheduleCoachListQuery';
import CoachMark from '#shared/CoachMark';
import { ReservedMembersType } from '#types/schedule';
import getFirstDayOfWeek from '#utils/getFirstDayOfWeek';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import Loading from 'src/components/molecules/Loading';
import CalendarHeader from '../components/CalendarHeader';
import CardMemoWrapper from '../components/CardMemoWrapper';
import CurrentIndicator from '../components/CurrentIndicator';
import DatePicker from '../components/DatePicker';
import HeaderWeekDay from '../components/HeaderWeekDay';
import Timeline from '../components/Timeline';
import useDateBasedColumns from '../hooks/useDateBasedColumns';
import * as S from '../styles';
import { CalendarPeriodic } from '../types';
import EmptyCoachMark from './EmptyCoachMark';
import LectureCoachMark from './LectureCoachMark';
import { TimelineWrapper } from './styles';

export default function WeeklyCalendar() {
  const [searchParams] = useSearchParams();
  const startAtParam = searchParams.get('startAt');
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const [calendarPeriodic, setCalendarPeriodic] =
    useState<CalendarPeriodic>('WEEKLY');

  const [activeDate, setActiveDate] = useState<dayjs.Dayjs>();

  const { data, isLoading } = useScheduleCoachListQuery({
    startAt: activeDate ? activeDate?.format('YYYY-MM-DD') : '',
    durationDays: calendarPeriodic === 'WEEKLY' ? 7 : 1
  });

  const handleChangeDate = (date: dayjs.Dayjs) => {
    const queryParams = new URLSearchParams(search);
    queryParams.set('startAt', date.format('YYYY-MM-DD'));
    navigate(`${pathname}?${queryParams.toString()}`);
  };

  const columns = useDateBasedColumns({ data, calendarPeriodic, activeDate });

  useEffect(() => {
    if (calendarPeriodic === 'WEEKLY') {
      setActiveDate(
        getFirstDayOfWeek(startAtParam ? dayjs(startAtParam) : dayjs())
      );
    } else {
      setActiveDate(startAtParam ? dayjs(startAtParam) : dayjs());
    }
  }, [startAtParam, calendarPeriodic]);

  return (
    <S.Root>
      <CoachMark />

      <LectureCoachMark />

      <EmptyCoachMark />

      {isLoading && (
        <S.LoadingWrapper>
          <Loading />
        </S.LoadingWrapper>
      )}
      {/* <div style={{ padding: '20px 20px 0' }}>
        <CalendarHeader
          activeDate={activeDate}
          defaultCalendarPeriodic={calendarPeriodic}
          onChangePeriodic={value => {
            setCalendarPeriodic(value);
            // const queryParams = new URLSearchParams(search);
            // queryParams.set('periodic', value);
            // navigate(`${pathname}?${queryParams.toString()}`);
          }}
        /> */}
      {/* </div> */}
      <S.StickyHeader style={{ paddingTop: '10px' }}>
        <CardMemoWrapper
          calendarPeriodic={calendarPeriodic}
          date={activeDate}
        />
        <DatePicker
          calendarPeriodic={calendarPeriodic}
          date={activeDate}
          onChange={handleChangeDate}
        />

        {calendarPeriodic === 'WEEKLY' && <HeaderWeekDay columns={columns} />}
      </S.StickyHeader>
      <TimelineWrapper>
        <CurrentIndicator />
        <Timeline
          columns={columns}
          activeDate={activeDate as dayjs.Dayjs}
          onClickSchedule={data => {
            if (data.isPersonalSchedule) {
              navigate(
                // @ts-ignore
                `${PATH.CALENDER_PERSONAL_DETAIL}/${data.personalScheduleId!}`
              );

              return;
            }

            navigate(
              `${PATH.CALENDER_DETAIL}/${(data as ReservedMembersType).id}`
            );
          }}
        />
      </TimelineWrapper>
    </S.Root>
  );
}
